import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { useApi } from "../../lib/useApi";
import { api, formatApiError } from "../../lib/api";

export default function TemplatesTab({ canManage }) {
  const { data, reload } = useApi("/company/email-templates");
  const [f, setF] = useState({ name: "", subject: "", body: "" });
  const save = async () => { try { await api.post("/company/email-templates", f); setF({ name: "", subject: "", body: "" }); toast.success("Modèle enregistré"); reload(); } catch (e) { toast.error(formatApiError(e)); } };
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <div className="space-y-3" data-testid="templates-list">
        {(data || []).map((t) => (
          <div key={t.id} className="card-surface p-4" data-testid={`template-${t.id}`}>
            <div className="flex items-center"><p className="flex-1 font-medium">{t.name}</p>
              {canManage && <button className="text-rose-600" onClick={async () => { await api.delete(`/company/email-templates/${t.id}`); reload(); }} data-testid={`template-delete-${t.id}`}><Trash2 className="h-3.5 w-3.5" /></button>}</div>
            <p className="text-xs text-slate-500">Objet : {t.subject}</p><p className="mt-1 line-clamp-3 whitespace-pre-wrap text-sm text-slate-600">{t.body}</p>
          </div>
        ))}
        {data && !data.length && <p className="text-sm text-slate-500">Aucun modèle.</p>}
      </div>
      {canManage && (
        <div className="card-surface space-y-3 p-5" data-testid="template-editor">
          <p className="font-display font-semibold">Nouveau modèle</p>
          <Input placeholder="Nom du modèle" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="template-name-input" />
          <Input placeholder="Objet" value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} data-testid="template-subject-input" />
          <Textarea rows={6} placeholder="Bonjour {{nom}}, …" value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} data-testid="template-body-input" />
          <Button onClick={save} data-testid="template-save-button">Enregistrer</Button>
        </div>
      )}
    </div>
  );
}
